// 全局注入地图
const DsfCommonCenterMap = dsf.defineAsyncComponent("DsfCommonCenterMap", () => import(/* webpackChunkName: "map-tool" */ "./components/common/centerMap.vue"));
const DsfMapColorLegend = dsf.defineAsyncComponent("DsfMapColorLegend", () => import(/* webpackChunkName: "map-tool" */ "./components/colorLegend/colorLegend.vue"));

const components = [DsfCommonCenterMap, DsfMapColorLegend]
function install(Vue) {
  components.forEach((it) => {
    let name = dsf.isFunction(it) ? (it.ctrlName||key) : it.name;
    Vue.component(name, it);
    if (!window.$components['map']) {
      window.$components['map'] = {}
    }
    window.$components['map'][it.name] = it;
  })
}
export default install;

export { install };
